import { BrowserRouter } from "react-router";
import { ICookieConsentDialogStrings, BNMaterialUI } from "..";
import { RegionId } from "../Contract/RegionId";
import CookieConsent from "./CookieConsent";
import { CookieConsentStringContext } from "./CookieConsentStringContext";
import { useEffect, useState } from "react";

export interface CookieConsentSettingsModel {
  disableCookieConsentForMarketingAndPersonalisation: boolean;
  isApp: boolean;
  localization: ICookieConsentDialogStrings;
  region: RegionId;
  cookieConsentApp: boolean;
}
interface Props {
  standalone: boolean;
}
const CookieConsentApp: React.FC<Props> = ({ standalone }) => {
  const [cookieConsentSettings, setCookieConsentSettings] = useState<CookieConsentSettingsModel>();
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch(
      `/c/api/v1/spaInitObject/cookieconsent?v=2&path=${
        document.location.pathname
      }${document.location.search.replace("?", "&")}`,
    )
      .then((response) => {
        return response.json();
      })
      .then(setCookieConsentSettings);
  }, []);
  if (!cookieConsentSettings) {
    return <></>;
  }

  if (cookieConsentSettings.isApp && !cookieConsentSettings.cookieConsentApp) {
    return <></>;
  }

  if (standalone) {
    return (
      <CookieConsentStringContext.Provider value={cookieConsentSettings.localization}>
        <BrowserRouter>
          <BNMaterialUI htmlFontSize={10} cssBaseLineEnabled>
            <CookieConsent settings={cookieConsentSettings} />
          </BNMaterialUI>
        </BrowserRouter>
      </CookieConsentStringContext.Provider>
    );
  }
  return (
    <CookieConsentStringContext.Provider value={cookieConsentSettings.localization}>
      <CookieConsent settings={cookieConsentSettings} />
    </CookieConsentStringContext.Provider>
  );
};

export default CookieConsentApp;
